import { deleteRequest, postRequest, getRequest, putRequest } from 'features/common'
import settings from 'settings'
import { CredentialType, M2MOauthClient, OAuthClient, OAuthClientType, SpaOauthClient } from '../types'

function baseUrl() {
  const { accountsApiUrl } = settings
  return `${accountsApiUrl}/oauth-clients`
}

export const getOAuthClients = async (type: OAuthClientType): Promise<Array<OAuthClient>> => {
  const oauthClients = await getRequest(`${baseUrl()}?type=${type}`)
  return oauthClients
}

export const getOAuthClient = async <T>(id: string): Promise<T> => {
  const oauthClient = await getRequest(`${baseUrl()}/${id}`)
  return oauthClient
}

export const updateSpaOAuthClient = async ({
  id,
  ...spaConfig
}: {
  id: string
} & SpaOauthClient): Promise<OAuthClient> => {
  const oauthClient = await putRequest(`${baseUrl()}/${id}`, { ...spaConfig, type: CredentialType.SPA })
  return oauthClient
}

export const updateM2MOAuthClient = async ({
  id,
  ...m2mConfig
}: {
  id: string
} & M2MOauthClient): Promise<OAuthClient> => {
  const oauthClient = await putRequest(`${baseUrl()}/${id}`, { ...m2mConfig, type: CredentialType.M2M })
  return oauthClient
}

export const createSpaOAuthClient = async (spaConfig: SpaOauthClient): Promise<OAuthClient> => {
  const oauthClient = await postRequest(baseUrl(), { ...spaConfig, type: CredentialType.SPA })
  return oauthClient
}

export const createM2MOAuthClient = async (m2mConfig: M2MOauthClient): Promise<OAuthClient> => {
  const oauthClient = await postRequest(baseUrl(), { ...m2mConfig, type: CredentialType.M2M })
  return oauthClient
}

export const removeOAuthClients = async (id: string): Promise<{ status }> => {
  return await deleteRequest(`${baseUrl()}/${id}`)
}
